import { render } from "./canvas.component.light.vue?vue&type=template&id=790638bd&scoped=true"
import script from "./canvas.component.light.vue?vue&type=script&lang=js"
export * from "./canvas.component.light.vue?vue&type=script&lang=js"

import "./canvas.component.light.vue?vue&type=style&index=0&id=790638bd&scoped=true&lang=css"

import exportComponent from "/Users/djones/Desktop/repos/davyjones-me/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790638bd"]])

export default __exports__